import React, { createContext, useContext, useEffect, useState } from "react";

const ActiveRoleContext = createContext();

/**
 * Provider die de actieve rol opslaat en beschikbaar maakt in de app
 */
export const ActiveRoleProvider = ({ children }) => {
    const [activeRole, setActiveRole] = useState(null);

    // Bij laden kijken of er iets in localStorage staat
    useEffect(() => {
        const stored = localStorage.getItem("activeRole");
        if (stored === "admin" || stored === "parent") {
            setActiveRole(stored);
        }
    }, []);

    // Rol zetten + opslaan in localStorage
    const handleSetActiveRole = (role) => {
        if (role === "admin" || role === "parent") {
            setActiveRole(role);
            localStorage.setItem("activeRole", role);
        }
    };

    return (
        <ActiveRoleContext.Provider value={{ activeRole, setActiveRole: handleSetActiveRole }}>
            {children}
        </ActiveRoleContext.Provider>
    );
};

/**
 * Hook om de actieve rol te gebruiken
 */
export const useActiveRole = () => {
    const ctx = useContext(ActiveRoleContext);
    if (!ctx) {
        throw new Error("useActiveRole must be used within ActiveRoleProvider");
    }
    return ctx;
};